import styled from 'styled-components'

import { COLORS, typeScale } from '../../styles'
import Icon from '../Icon'

const Styled = styled.div`
  border-radius: 9999px;
`
Styled.imageContainer = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 9999px;
  overflow: hidden;
  box-sizing: border-box;
  background: ${({ imageLoaded }) => (imageLoaded ? 'none' : COLORS.white)};
  position: relative;
  border: 0;
`
Styled.image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`
Styled.imageBroken = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 9999px;
  border: 0.2rem dashed ${COLORS.yolk};
  display: flex;
  align-items: center;
  justify-content: center;
`
Styled.icon = styled(Icon)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.information = styled.div`
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`
Styled.name = styled.span`
  ${typeScale('caption')};
  margin-left: 0.8rem;
`

export default Styled
